import { Box3, Camera, MOUSE, OrthographicCamera, PerspectiveCamera, Quaternion, Spherical, Ray, Raycaster, Color, Vector2, Mesh, SphereGeometry, Vector3, MeshBasicMaterial, Scene, Object3D, BufferGeometry, LineBasicMaterial, Line } from "three";
import { OutlinePass } from 'three/examples/jsm/postprocessing/OutlinePass.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';


export const VIEW_STATE = {
    NONE: - 1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
}

export class ViewChange {
    target: Vector3 = new Vector3();
    domElement: HTMLCanvasElement;
    camera: Camera
    zoomSpeed: number = 2.0;
    zoomCenter: Vector3 = new Vector3();
    rotateCenter: Vector3 = new Vector3(0, 0, 0);
    cameraEdge = 100;
    rotateSpeed: number = 1;
    panSpeed: number = 1.0;
    scene: Scene
    // outlinePass: OutlinePass

    private _pointerStart: Vector2 = new Vector2();
    private _pointerEnd: Vector2 = new Vector2();
    private _pointerDelta: Vector2 = new Vector2();
    private _state = VIEW_STATE.NONE;
    private _spherical = new Spherical();
    private _quat: Quaternion = new Quaternion();
    private _quatInverse: Quaternion = new Quaternion();
    private _panOffset = new Vector3();

    changeSelect: (entity: Object3D[]) => void

    resetEdit: () => void

    private _onEditView: number = 0

    constructor(domElement: HTMLCanvasElement, camera: Camera, scene: Scene, changeSelect: (entity: Object3D[]) => void, resetEdit: () => void) {
        this.domElement = domElement
        this.camera = camera
        this.scene = scene
        this.changeSelect = changeSelect
        this.resetEdit = resetEdit

        this.domElement.addEventListener('pointerdown', this.onPointerDown);
        this.domElement.addEventListener('pointermove', this.onPointerMove);
        this.domElement.addEventListener('pointerup', this.onPointerUp);
        this.domElement.addEventListener('wheel', this.onMouseWheel);
    }

    dispose = () => {
        this.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.domElement.removeEventListener('pointerup', this.onPointerUp);
        this.domElement.removeEventListener('wheel', this.onMouseWheel);
    }

    onPointerDown = (event) => {
        switch (event.pointerType) {
            case 'mouse':
            case 'pen':
                this.onMouseDown(event);
                break;
        }
    }


    onKeyDown = (event) => {
        console.log('event', event)
    }

    onPointerMove = (event) => {
        switch (event.pointerType) {
            case 'mouse':
            case 'pen':
                this.onMouseMove(event);
                break;

            // TODO touch
        }
    }

    onPointerUp = (event) => {
        switch (event.pointerType) {
            case 'mouse':
            case 'pen':
                this.onMouseUp(event);
                break;

            // TODO touch
        }
    }

    onMouseUp = (event) => {
        this._state = VIEW_STATE.NONE;
    }

    changeViewState = (value: number) => {
        this._onEditView = value
    }

    onMouseDown = (event) => {
        event.preventDefault();
        this.domElement.focus ? this.domElement.focus() : window.focus();
        this._state = VIEW_STATE.NONE;

        switch (event.button) {
            case MOUSE.LEFT:
                // this._state = VIEW_STATE.ROTATE;
                // this._rotateStart.set(event.offsetX, event.offsetY);
                if (this._onEditView == 0) {
                    this.selectEntity(event)
                } else if (this._onEditView == 1) {
                    this._state = VIEW_STATE.PAN
                } else if (this._onEditView == 2) {
                    this._state = VIEW_STATE.ROTATE
                }
                break;
            case MOUSE.MIDDLE:
                if (this._onEditView == 0) {
                    if (event.shiftKey) {
                        this._state = VIEW_STATE.ROTATE;
                    } else {
                        this._state = VIEW_STATE.PAN
                    }
                } else if (this._onEditView == 1) {
                    this._state = VIEW_STATE.PAN
                } else if (this._onEditView == 2) {
                    this._state = VIEW_STATE.ROTATE
                }

                break;
            case MOUSE.RIGHT:
                this.resetEdit()
                break;
            default:
                this._state = VIEW_STATE.NONE;
        }

        this._pointerStart.set(event.offsetX, event.offsetY);
    }

    onMouseWheel = (event) => {
        this.domElement.focus ? this.domElement.focus() : window.focus();
        event.preventDefault();
        const speed = this.zoomSpeed
        let zoomScale = Math.round(Math.pow(0.92, speed) * 100) / 100;
        if (event.deltaY < 0) {
            // zoomIn 放大
            this.handleZoom(1 / zoomScale, event);
        } else if (event.deltaY > 0) {
            // zoomOut 缩小
            this.handleZoom(zoomScale, event);
        }
        let cameraPosition = this.camera.position?.clone()
        this.updateZoomCenter(event);
    }

    onMouseMove = (event) => {

        event.preventDefault();

        this._pointerEnd.set(event.offsetX, event.offsetY);
        this._pointerDelta.subVectors(this._pointerEnd, this._pointerStart)

        if (this._state === VIEW_STATE.ROTATE) {
            this.camera.up.set(0, 0, 1);
            this._quat = new Quaternion().setFromUnitVectors(this.camera.up, new Vector3(0, 1, 0));
            this._quatInverse = this._quat.clone().invert();
            this.handleRotate(event);
        } else if (this._state === VIEW_STATE.PAN) {
            this.handlePan(event);
        }
        this.updateZoomCenter(event);

        this._pointerStart.set(event.offsetX, event.offsetY);

    }

    private _perspectiveDir = new Vector3();
    private _cameraLookAt = new Vector3();
    handleZoom = (zoomScale: number, event) => {
        if (this.cameraEdge < 5 && zoomScale > 1) return;
        this.cameraEdge /= zoomScale;
        let camera = this.camera;
        let _target = this.target.clone();
        // let _lastZoom = camera.zoom;
        if (camera.type === 'OrthographicCamera') {
            this.updateTarget(this.zoomCenter);
            let orthoCamera = camera as OrthographicCamera;
            orthoCamera.left = orthoCamera.left / zoomScale;
            orthoCamera.right = orthoCamera.right / zoomScale;
            orthoCamera.top = orthoCamera.top / zoomScale;
            orthoCamera.bottom = orthoCamera.bottom / zoomScale;
            orthoCamera.far = orthoCamera.far / zoomScale;
            // orthoCamera.near = orthoCamera.near / zoomScale;
            orthoCamera.updateProjectionMatrix();


            // update target
            let v1 = this.zoomCenter.clone().sub(_target);
            // v1.multiplyScalar(_lastZoom / camera.zoom);
            v1.multiplyScalar(1 / zoomScale);
            let new_target = this.zoomCenter.sub(v1);
            this.updateTarget(new_target);

            let dir = this.target.clone().sub(orthoCamera.position);
            dir.multiplyScalar(1 / zoomScale);
            orthoCamera.position.copy(new_target).sub(dir);
            orthoCamera.updateProjectionMatrix();


        }
        // else if (camera.type === 'PerspectiveCamera') {
        //     // let  cursorPoint = 
        //     // new Vector3().copy(camera.position)
        //     //              .addScaledVector(new Vector3(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z)
        //     //              .sub(camera.position).normalize(), 300);  //获取当前鼠标点的世界坐标
        //     // let oldNDC = cursorPoint.clone().project(camera);

        //     //对于透视相机的视图操作，即平移相机所在点，相机距离物体越近，物体越大
        //     let persCamera = camera as PerspectiveCamera;
        //     persCamera.getWorldDirection(this._cameraLookAt);//获取相机目视方向
        //     this._perspectiveDir.copy(persCamera.position).sub(this.extraContext.sceneContext.scene.position)  //相机目视点到场景的距离，根据这个距离对相机进行缩放
        //     persCamera.position.addScaledVector(this._cameraLookAt, this._perspectiveDir.length() * (zoomScale - 1)); //相机目视点平移
        //     persCamera.updateProjectionMatrix();
        // }
    }

    handlePan = (event) => {

        let camera = this.camera;

        let deltaX = this._pointerDelta.x * this.panSpeed;
        let deltaY = this._pointerDelta.y * this.panSpeed;

        const element = this.domElement;
        if (camera.type === 'OrthographicCamera') {
            let orthoCamera = camera as OrthographicCamera;
            const position = orthoCamera.position;
            const cameraMatrix = orthoCamera.matrix;
            const distanceX = deltaX * (orthoCamera.right - orthoCamera.left) / orthoCamera.zoom / element.clientWidth;
            const distanceY = deltaY * (orthoCamera.top - orthoCamera.bottom) / orthoCamera.zoom / element.clientHeight;

            let offset = this._offset;
            offset.copy(position).sub(this.target);

            // pan left
            let v = new Vector3();
            v.setFromMatrixColumn(cameraMatrix, 0);
            v.multiplyScalar(-distanceX)
            this._panOffset.add(v);

            // pan up
            v.setFromMatrixColumn(cameraMatrix, 1);

            v.multiplyScalar(distanceY);
            this._panOffset.add(v);

            this.target.add(this._panOffset);
            position.copy(this.target).add(offset);
            orthoCamera.updateMatrixWorld();

        } else if (camera.type === 'PerspectiveCamera') {
            //透视相机与正交相机相比，只是平移长度的计算方式不一致，其他方式是一致的
            let persCamera = camera as PerspectiveCamera;

            const position = persCamera.position;
            const cameraMatrix = persCamera.matrix;
            let offset = this._offset;
            offset.copy(position).sub(this.target);

            let targetDistance = offset.length();

            // half of the fov is center to top of screen
            targetDistance *= Math.tan((persCamera.fov / 2) * Math.PI / 180.0);

            const distanceX = 2 * deltaX * targetDistance / element.clientHeight;
            const distanceY = 2 * deltaY * targetDistance / element.clientHeight;

            // pan left
            let v = new Vector3();
            v.setFromMatrixColumn(cameraMatrix, 0);
            v.multiplyScalar(-distanceX)
            this._panOffset.add(v);

            // pan up
            v.setFromMatrixColumn(cameraMatrix, 1);

            v.multiplyScalar(distanceY);
            this._panOffset.add(v);

            this.target.add(this._panOffset);
            position.copy(this.target).add(offset);
            persCamera.updateMatrixWorld();
        }


        if (this.camera && (this.camera.type === 'OrthographicCamera' || this.camera.type === 'PerspectiveCamera')) {
            (this.camera as OrthographicCamera | PerspectiveCamera).updateProjectionMatrix();
        }
        this._panOffset.set(0, 0, 0);
        this.update();

    }

    private _offset: Vector3 = new Vector3();
    handleRotate = (event) => {
        let camera = this.camera;

        let theta_delta = -2 * Math.PI * this._pointerDelta.x * this.rotateSpeed / this.domElement.clientHeight;
        let phi_delta = -2 * Math.PI * this._pointerDelta.y * this.rotateSpeed / this.domElement.clientHeight;

        let spherical = this._spherical;
        const position = camera.position;
        let _target = this.target.clone();

        this.updateTarget(this.rotateCenter);

        // 3d-vector: offset = camera position - target position
        let offset = this._offset;

        offset.copy(position).sub(this.target);
        // let lastOffset = offset.clone();
        let rotateAxis1 = camera.up.clone().normalize();
        let rotateAxis2 = camera.up.clone().cross(offset).normalize();

        // rotate offset to "y-axis-is-up" space
        offset.applyQuaternion(this._quat);

        // transfer offset vector to spherical coords
        spherical.setFromVector3(offset);
        let last_theta = spherical.theta
        let last_phi = spherical.phi
        // let lastSpherical = spherical.clone();

        // add delta to spherical offset vector
        spherical.theta += theta_delta;
        spherical.phi += phi_delta;


        // restrict phi to be between desired limits
        spherical.makeSafe();
        theta_delta = spherical.theta - last_theta
        phi_delta = spherical.phi - last_phi

        // transfer offset back to cartesian coords
        offset.setFromSpherical(spherical);
        // rotate offset back to "camera-up-vector-is-up" space
        offset.applyQuaternion(this._quatInverse);
        position.copy(this.target).add(offset);
        camera.lookAt(this.target)

        let _oq = new Quaternion().setFromAxisAngle(rotateAxis1, theta_delta).multiply(new Quaternion().setFromAxisAngle(rotateAxis2, phi_delta));
        let v1 = _target.clone().sub(this.rotateCenter);
        v1.applyQuaternion(_oq);
        let new_target = this.rotateCenter.clone().add(v1);
        this.updateTarget(new_target)

        this.update();
    }

    nearVec: Vector3 = new Vector3()
    farVec: Vector3 = new Vector3()
    rayOrigin: Vector3 = new Vector3()
    dir: Vector3 = new Vector3()
    selectEntity = (event) => {
        const mouse = new Vector2();
        mouse.x = (event.offsetX / this.domElement.clientWidth) * 2 - 1;
        mouse.y = -(event.offsetY / this.domElement.clientHeight) * 2 + 1;

        // raycaster.setFromCamera(mouse, this.camera);
        this.farVec.set(mouse.x, mouse.y, -1)
        this.nearVec.set(mouse.x, mouse.y, 1)

        this.nearVec.unproject(this.camera);
        this.farVec.unproject(this.camera);

        this.rayOrigin.copy(this.nearVec)

        this.dir.copy(this.farVec).sub(this.nearVec).normalize();
        let raycaster = new Raycaster(this.rayOrigin, this.dir)
        const intersects = raycaster.intersectObjects(this.scene.children, false);
        this.changeSelect(intersects.map((item) => { return item.object }))


        // if (intersects.length > 0) {
        //     this.changeSelect(intersects[intersects.length - 1].object)
        // } else {
        //     this.changeSelect(null)
        // }

    }

    // 显示所有图元
    showAllEntities = (box: Box3) => {
        box.min.project(this.camera);
        box.max.project(this.camera);
        this.showEntitiesInRect(box.min.x, box.min.y, box.max.x, box.max.y, 1.3);
    }

    showEntitiesInRect = (x1, y1, x2, y2, alpha = 1) => {
        let scale1 = Math.abs(y1 - y2) / 2;
        let scale2 = Math.abs(x1 - x2) / 2;
        let scale = Math.max(scale1, scale2) * alpha;
        let x = (x1 + x2) / 2;
        let y = (y1 + y2) / 2;

        let camera = this.camera as OrthographicCamera;
        let target = this.unprojectCursorPoint(x, y, camera);
        let lastTarget = this.target.clone();
        let offset = camera.position.clone().sub(lastTarget);
        const position = camera.position;
        this.target.copy(target);
        offset.multiplyScalar(scale);
        position.copy(target).add(offset);
        this.camera.lookAt(target);
        // scale 框和当前边界的比例
        this.cameraEdge *= scale;
        camera.left = camera.left * scale;
        camera.right = camera.right * scale;
        camera.top = camera.top * scale;
        camera.bottom = camera.bottom * scale;
        camera.far = camera.far * scale;
        camera.updateProjectionMatrix();
    }

    unprojectCursorPoint = (x, y, camera) => {
        const _rayStart = new Vector3();
        const _rayEnd = new Vector3();

        _rayStart.set(x, y, -1).unproject(camera);
        _rayEnd.set(x, y, 1).unproject(camera);

        const target = new Vector3();
        const normal = new Vector3();
        normal.set(0, 0, 1);

        const direction = _rayEnd.clone().sub(_rayStart);
        const denominator = normal.dot(direction);
        if (denominator === 0) {
            if (new Vector3(0, 0, 1).dot(_rayStart) === 0) {
                return target.copy(_rayStart);
            }
            return null;
        }

        const t = -(_rayStart.dot(normal) + (-0)) / denominator;
        if (t < 0 || t > 1) {
            return null;
        }

        return target.copy(direction).multiplyScalar(t).add(_rayStart);
    }

    updateTarget = (v: Vector3) => {
        const position = this.camera.position;
        let offset = position.clone().sub(this.target);
        this.target.set(v.x, v.y, v.z);
        position.copy(this.target).add(offset);
        this.camera.updateMatrixWorld();
        if (this.camera && (this.camera.type === 'OrthographicCamera' || this.camera.type === 'PerspectiveCamera')) {
            (this.camera as OrthographicCamera | PerspectiveCamera).updateProjectionMatrix();
        }
    }

    updateZoomCenter = (event) => {
        let camera = this.camera;
        let _target = this.target.clone();
        const element = this.domElement;
        if (camera.type === 'OrthographicCamera') {
            const position = camera.position;
            let orthoCamera = camera as OrthographicCamera;
            let mouse = new Vector2(event.offsetX, event.offsetY);
            //鼠标在投影面上距中心点的距离
            let pos_x = (mouse.x - element.clientWidth / 2) * (orthoCamera.right - orthoCamera.left) / orthoCamera.zoom / element.clientWidth;
            let pos_y = (element.clientHeight / 2 - mouse.y) * (orthoCamera.top - orthoCamera.bottom) / orthoCamera.zoom / element.clientHeight;
            let offset = position.clone().sub(_target).normalize();
            let camera_u_axis = camera.up.clone().cross(offset).normalize();
            let camera_v_axis = offset.clone().cross(camera_u_axis).normalize();
            let mousePos = _target.clone().add(camera_u_axis.multiplyScalar(pos_x)).add(camera_v_axis.multiplyScalar(pos_y));
            this.zoomCenter.set(mousePos.x, mousePos.y, mousePos.z);

        }
    }

    update = () => {
        // render

    }
}